module.exports = __webpack_public_path__ + "img/Rectangle 10120.d7eeca70.svg";